import { createFileRoute } from '@tanstack/react-router';

import { PublicPaymentWrapper } from '../components/PublicPayment';

export const Route = createFileRoute('/payment/$token')({
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useParams();

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicPaymentWrapper
        token={token}
        onCancel={() => {
          // For dev testing, just show an alert or navigate to home
          alert('Payment cancelled');
          window.location.href = '/';
        }}
      />
    </div>
  );
}
